<template>
  <div class="debugInfo">
    <div class="deviceHeader">
      <div class="deviceHeaderLeft">
        <div class="closepage" @click="goList"></div>
        <div>{{ `${$t('device.deviceDebug')}` }}</div>
      </div>
    </div>
    <div class="deviceBody">
      <el-form class="grid">
        <el-form-item :label="$t('datalogger.datalogger_pn')" size="small">
          <div>{{ deviceInfo.pn }}</div>
        </el-form-item>
        <el-form-item :label="$t('datalogger.communication_address')" size="small">
          <el-input :disabled="true" class="devaddrClass" type="number" v-model="deviceInfo.devaddr" auto-complete="off"  oninput="if(value<1)value=1;if(value>255)value=255"></el-input>
        </el-form-item>
        <el-form-item v-if="deviceDebugFlag" :label="$t('datalogger.InstructionType')" size="small">
          <el-radio-group v-model="patternType" style="width: 100%;">
            <el-radio :label="1">HEX</el-radio>
            <el-radio :label="2">ASCII</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('datalogger.Instruction')" size="small">
          <el-input :rows="4" v-model="devDebug.cmd" :placeholder="patternType==1?$t('datalogger.such_as'):''" type="textarea"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="patternType==2" :label="$t('datalogger.check')" size="small">
          <el-radio-group v-model="devcodeCheck" style="width: 100%;">
            <el-radio :label="1">{{ $t('datalogger.noCheck')}}</el-radio>
            <el-radio :label="2">CRC-XMOODEM</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="patternType==2" :label="$t('datalogger.endMarker')" size="small">
          <el-radio-group v-model="devcodeType" style="width: 100%;">
            <el-radio :label="1">{{ $t('datalogger.noMarker')}}</el-radio>
            <el-radio :label="2">0D</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label=" ">
          <div style="text-align:right;">
            <button type="button" class="btn btn-dark" @click="submitDebugDatalogger()">{{ $t('datalogger.send')}}</button>
          </div>
        </el-form-item>
        <el-form-item v-if="patternType==2&&cmdVal" :label="$t('datalogger.InstructionIssue')" size="small">
          <div>{{ cmdVal }}</div>
        </el-form-item>
        <el-form-item :label="$t('datalogger.return_content')" size="small">
          <div class="debug-return">
            <div class="return-tool">
              <span class="btn" style="margin-right:15px;" @click="fuzhi($event)" data-clipboard-action="copy"
                data-clipboard-target="#link">
                <i class="ico ico-copy"></i>
                {{ $t('device.copy_val') }}
              </span>
              <span class="btn" @click="qingkong()">
                <i class="ico ico-clear"></i>
                {{ $t('device.clear_val') }}
              </span>
            </div>
            <el-input :rows="10" readonly id="link" v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import clipboard from "@/assets/js/clipboard";
export default{
  components:{
    
  },
  data(){
    return{
      deviceDebugFlag:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08")||false,
      datalogger: {
        devaddr: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
      patternType: 1,
      devcodeCheck: 2,
      devcodeType: 2,
      cmdVal: '',
    };
  },
  computed: {
    ...mapGetters({
      getIsShow: 'getIsShow',
      deviceInfo: 'getDeviceInfo',
      dataloggerDetail: 'getDataloggerDetail'
    }),
  },
  beforeDestroy(){
  },
  created () {
  },
  methods:{
    // 调试清空
    qingkong () {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 调试复制
    fuzhi (event) {
      clipboard(this.debugReturn, event);
    },
    // CRC校验
    crc16Xmodem(data) {
        let crc = 0x0000;
        const poly = 0x1021;

        for (let i = 0; i < data.length; i++) {
            crc ^= (data[i] << 8);
            for (let j = 0; j < 8; j++) {
                if (crc & 0x8000) {
                    crc = (crc << 1) ^ poly;
                } else {
                    crc <<= 1;
                }
                crc &= 0xFFFF;
            }
        }
        return crc;
    },
    // 指令拼接
    cmdValue(value){
      const hexStr = value;
      const data = hexStr.split(' ').map(b => parseInt(b, 16));
      // 3. 计算并追加 CRC
      const crc = this.crc16Xmodem(data);
      const result = [...data, (crc >> 8) & 0xFF, crc & 0xFF];
      // 4. 输出结果
      console.log(result.map(b => b.toString(16).padStart(2, '0').toUpperCase()).join(' '));
      return result.map(b => b.toString(16).toUpperCase().padStart(2, '0')).join(' ')
    },
    // 发送指令
    submitDebugDatalogger () {
      if (this.datalogger.devaddr == null) {
        this.$message.error(this.$t("datalogger.devaddrfail"));
      } else if (this.deviceInfo.status == "1") {
        this.$message.error(this.$t("datalogger.Debugfail"));
      } else {
        this.debugReturn = this.$t("datalogger.instruction_response");
        let cmd=''
        if(this.patternType==2){
          cmd=Buffer.from(this.devDebug.cmd, 'utf8').toString('hex')
          .match(/.{1,2}/g).join(' ');
          if (this.devcodeCheck==2) {
            cmd=this.cmdValue(cmd);
          }
          if (this.devcodeType==2) {
            cmd = cmd + ' ' + "0D";
          }
        }else{
          cmd = this.devDebug.cmd;
        }
        this.cmdVal=cmd
        let param = {
          pn: this.deviceInfo.pn,
          devaddr: this.deviceInfo.devaddr,
          cmd: cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("datalogger.debug_suc"));
            this.debugReturn = res.dat.dat;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 返回列表
    goList(){
      this.$store.commit('saveIsShow', 1);
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.debugInfo{
  display: flex;
  flex: 1;
  flex-direction: column;
  .deviceHeader{
    display: flex;
    font-size: 20px;
    color: #ffffff;
    justify-content: space-between;
    align-items: center;
    background-color: #222d35;
    .deviceHeaderLeft{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      div:last-child{
        padding-left: 30px;
        font-weight: 700;
      }
      .closepage {
        display: inline-block;
        background-color: #23323D;
        width: 60px;
        height:56px;
        background-image: url('../../../../assets/img/general/arrow_left.png');
        background-size: 24px 24px;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }
  }
  .deviceBody{
    height: 100%;
    background-color: #222d35;
    margin-top: 10px;
    padding:20px 500px 20px 110px ;
    color: #fff;
    .devaddrClass{
      width: 200px;
    }
    /deep/.el-form-item__label{
      color: #fff;
      height: 100%;
    }
    /deep/.el-input__inner{
      border-color: rgba(204, 206, 221, 0.5);;
      background: #2b3842;
      color: #fff;
    }
    /deep/.el-textarea__inner {
      border-color: rgba(204, 206, 221, 0.5);;
      background: rgba(43, 56, 66, 1);
      color: #fff;
    }
    // 单选按钮主题色
    /deep/ .el-radio__inner {
      background-color: #2b3842;
      border-color: rgba(204, 206, 221, 0.5);
    }
    /deep/ .el-radio__inner:hover {
      border-color: @primaryColor;
    }
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      background-color: @primaryColor;
      border-color: @primaryColor;
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: @primaryColor;
    }
    /deep/ .el-radio__label {
      color: #fff;
    }
    // 统一按钮
    .btn {
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 14px;
      cursor: pointer;
    }

    .btn-dark {
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      border: none;
    }
    // 设备调试返回值
    .debug-return {
      border: 1px solid rgba(204, 206, 221, 0.5);
      border-radius: 4px;
      padding: 0 8px 5px;
      background: rgba(43, 56, 66, 1);

      /deep/.el-textarea__inner {
        border: none;
        background: rgba(43, 56, 66, 1);
        color: #fff;
      }
      /deep/ 

      .return-tool {
        border-bottom: 1px dashed rgba(204, 206, 221, 0.5);
        text-align: right;

        .btn:hover {
          color: @primaryTextColor;

          .ico-clear {
            background: url(../../../../assets/img/general/Icon_Debug_Delete_Dark.png);
          }

          .ico-copy {
            background: url(../../../../assets/img/general/Icon_Debug_Copy_Dark.png);
          }
        }

        .btn {
          padding: 0px;
          color: rgba(235, 235, 235, 1);
          font-size: 12px;
          cursor: pointer;
        }

        .ico-clear {
          background: url(../../../../assets/img/general/Icon_Debug_Delete.png);
        }

        .ico-copy {
          background: url(../../../../assets/img/general/Icon_Debug_Copy.png);
        }

        .ico {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>